// extracted by mini-css-extract-plugin
export var bounce = "_jh-1";
export var generatingText = "_jh-6";
export var lightning = "_jh-4";
export var popup = "_jh-5";
export var progressBar = "_jh-7";
export var progressFill = "_jh-8";
export var progressShimmer = "_jh-9";
export var progressText = "_jh-a";
export var shimmer = "_jh-3";
export var uploadIcon = "_jh-0";
export var uploadingText = "_jh-2";